import axios from "axios";

export const getLaravelApiToken = async (idToken) => {
  try {
    const response = await axios.post(
      "https://api.hackerthread.com/api/auth/token",
      {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );
    await localStorage.setItem("UserId", response.data.user_id);
    return response.data.token;
  } catch (error) {
    console.error("Error fetching Laravel API token:", error);
    return null;
  }
};

export const handleSignOut = async (signOutFunction, laravelApiToken) => {
  try {
    await axios.post(
      "https://api.hackerthread.com/api/auth/logout",
      {},
      {
        headers: {
          Authorization: `Bearer ${laravelApiToken}`,
        },
      }
    );
    signOutFunction();
  } catch (error) {
    console.error("Error during sign out:", error);
  }
};
